// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --max-width: 1300px;
  --min-width: 250px;

  --font-primary: 'Oswald', sans-serif;

  --text-xl: 1.5rem;
  --text-lg: 1.25rem;
  --text-md: 1rem;
  --text-sm: 0.75rem;
  --text-xs: 0.5rem;

  --input-xl: 30rem;
  --input-lg: 20rem;
  --input-md: 10rem;
  --input-sm: 5rem;
  --input-xs: 2.5rem;

  --global-light: #cbcdd2;
  --global-dark: #1c1d21;
  --global-darkest: #0f1012;
  --global-light-grey: #848794;
  --global-grey: #5d5d5d;
  --global-dark-grey: #45474f;

  --secondary-color: #4fb4d8;
  --primary-color: #8c5c15;
  --success-color: #ef7c2a;
  --danger-color: #395333;
  --warning-color: #76a1a5;

  --background: var(--global-darkest);
  --background-alt: var(--global-dark);
  --text-color: var(--success-color);
  --text-color-alt: var(--secondary-color);
  --hover-color: var(--text-color-alt);
  --hover-color-alt: var(--text-color);

  --box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.45);
  --inset-box-shadow: inset var(--box-shadow);

  --spacing: 1rem;
  --spacing-less: 0.25rem;
  --spacing-more: 3rem;

  --box-rounding: 5px;
  --border-size: 2px;
  --border-style: solid;
  --border-color: var(--success-color);
  --border-color-alt: var(--secondary-color);

  --transition: all 0.2s ease-in-out;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  min-width: auto;
  margin: 0;
  padding: 0;
  font-weight: normal;
}

body {
  background: var(--background);
  color: var(--text-color);
  min-height: 100%;
  transition:
    color 0.5s,
    background-color 0.5s;
  line-height: 1.5;
  font-family:
    var(--font-primary),
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image:
    radial-gradient(
      var(--secondary-color),
      rgba(255, 255, 255, 0.2) 5px,
      transparent 40px
    ),
    radial-gradient(
      var(--success-color),
      rgba(255, 255, 255, 0.15) 1px,
      transparent 30px
    ),
    radial-gradient(
      var(--success-color),
      rgba(255, 255, 255, 0.1) 2px,
      transparent 40px
    ),
    radial-gradient(
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0.1) 2px,
      transparent 30px
    );
  background-size:
    550px 550px,
    350px 350px,
    250px 250px,
    150px 150px;
  background-position:
    0 0,
    40px 60px,
    130px 270px,
    70px 100px;
}

ul {
  list-style: none;
}

li {
  padding: var(--spacing-less);
}

h1,
h2,
h3,
h4 {
  color: var(--text-color);
}

a {
  color: var(--secondary-color);
  text-decoration: none;
}

a:hover {
  color: var(--hover-color);
}

p {
  margin: var(--spacing-less) 0;
}

img {
  width: 100%;
  display: block;
}

hr {
  width: 75%;
}

input,
textarea {
  width: 100%;
  background: var(--global-dark);
  color: var(--primary-color);
  border: var(--primary-color) var(--border-size) var(--border-style);
  border-radius: var(--box-rounding);
  padding: var(--spacing-less) var(--spacing-less);
  margin: var(--spacing-less) var(--spacing-less);
}

input::file-selector-button {
  background: var(--background-alt);
  color: var(--text-color-alt);
  border: var(--border-size) var(--border-style) var(--border-color);
  border-radius: var(--box-rounding);
  padding: var(--spacing-less) var(--spacing);
  margin-right: var(--spacing);
  font-weight: bold;
}

input::file-selector-button:hover {
  color: var(--hover-color);
  border-color: var(--border-color-alt);
}

input[type='checkbox'] {
  width: auto;
  accent-color: var(--primary-color);
  cursor: pointer;
}

input[type='checkbox']:checked {
  accent-color: var(--secondary-color);
}

input[type='checkbox']:checked::before {
  font-weight: bold;
  color: var(--secondary-color);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}

button {
  display: inline-block;
  text-decoration: none;
  border: var(--border-size) var(--border-style) var(--border-color);
  background: var(--background-alt);
  color: var(--text-color-alt);
  border-radius: var(--box-rounding);
  font-weight: bold;
  font-size: larger;
  text-align: center;
  padding: var(--spacing-less) var(--spacing);
}

button:hover {
  color: var(--hover-color);
  border-color: var(--border-color-alt);
}

.app {
  min-width: var(--min-width);
  max-width: var(--max-width);
  margin: auto;
  padding: var(--spacing);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,kBAAkB;;EAElB,oCAAoC;;EAEpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;EAEjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;EAElB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;;EAE3B,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;EAClC,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;;EAEpC,iDAAiD;EACjD,2CAA2C;;EAE3C,eAAe;EACf,uBAAuB;EACvB,oBAAoB;;EAEpB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,0CAA0C;;EAE1C,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB;;yBAEuB;EACvB,gBAAgB;EAChB;;;;;;;;;;;;;cAaY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC;;;;;;;;;;;;;;;;;;;;KAoBG;EACH;;;;eAIa;EACb;;;;cAIY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mEAAmE;EACnE,kCAAkC;EAClC,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,kEAAkE;EAClE,kCAAkC;EAClC,2CAA2C;EAC3C,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kEAAkE;EAClE,iCAAiC;EACjC,4BAA4B;EAC5B,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');\n\n:root {\n  --max-width: 1300px;\n  --min-width: 250px;\n\n  --font-primary: 'Oswald', sans-serif;\n\n  --text-xl: 1.5rem;\n  --text-lg: 1.25rem;\n  --text-md: 1rem;\n  --text-sm: 0.75rem;\n  --text-xs: 0.5rem;\n\n  --input-xl: 30rem;\n  --input-lg: 20rem;\n  --input-md: 10rem;\n  --input-sm: 5rem;\n  --input-xs: 2.5rem;\n\n  --global-light: #cbcdd2;\n  --global-dark: #1c1d21;\n  --global-darkest: #0f1012;\n  --global-light-grey: #848794;\n  --global-grey: #5d5d5d;\n  --global-dark-grey: #45474f;\n\n  --secondary-color: #4fb4d8;\n  --primary-color: #8c5c15;\n  --success-color: #ef7c2a;\n  --danger-color: #395333;\n  --warning-color: #76a1a5;\n\n  --background: var(--global-darkest);\n  --background-alt: var(--global-dark);\n  --text-color: var(--success-color);\n  --text-color-alt: var(--secondary-color);\n  --hover-color: var(--text-color-alt);\n  --hover-color-alt: var(--text-color);\n\n  --box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.45);\n  --inset-box-shadow: inset var(--box-shadow);\n\n  --spacing: 1rem;\n  --spacing-less: 0.25rem;\n  --spacing-more: 3rem;\n\n  --box-rounding: 5px;\n  --border-size: 2px;\n  --border-style: solid;\n  --border-color: var(--success-color);\n  --border-color-alt: var(--secondary-color);\n\n  --transition: all 0.2s ease-in-out;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  min-width: auto;\n  margin: 0;\n  padding: 0;\n  font-weight: normal;\n}\n\nbody {\n  background: var(--background);\n  color: var(--text-color);\n  min-height: 100%;\n  transition:\n    color 0.5s,\n    background-color 0.5s;\n  line-height: 1.5;\n  font-family:\n    var(--font-primary),\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Fira Sans',\n    'Droid Sans',\n    'Helvetica Neue',\n    sans-serif;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-image:\n    radial-gradient(\n      var(--secondary-color),\n      rgba(255, 255, 255, 0.2) 5px,\n      transparent 40px\n    ),\n    radial-gradient(\n      var(--success-color),\n      rgba(255, 255, 255, 0.15) 1px,\n      transparent 30px\n    ),\n    radial-gradient(\n      var(--success-color),\n      rgba(255, 255, 255, 0.1) 2px,\n      transparent 40px\n    ),\n    radial-gradient(\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0.1) 2px,\n      transparent 30px\n    );\n  background-size:\n    550px 550px,\n    350px 350px,\n    250px 250px,\n    150px 150px;\n  background-position:\n    0 0,\n    40px 60px,\n    130px 270px,\n    70px 100px;\n}\n\nul {\n  list-style: none;\n}\n\nli {\n  padding: var(--spacing-less);\n}\n\nh1,\nh2,\nh3,\nh4 {\n  color: var(--text-color);\n}\n\na {\n  color: var(--secondary-color);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--hover-color);\n}\n\np {\n  margin: var(--spacing-less) 0;\n}\n\nimg {\n  width: 100%;\n  display: block;\n}\n\nhr {\n  width: 75%;\n}\n\ninput,\ntextarea {\n  width: 100%;\n  background: var(--global-dark);\n  color: var(--primary-color);\n  border: var(--primary-color) var(--border-size) var(--border-style);\n  border-radius: var(--box-rounding);\n  padding: var(--spacing-less) var(--spacing-less);\n  margin: var(--spacing-less) var(--spacing-less);\n}\n\ninput::file-selector-button {\n  background: var(--background-alt);\n  color: var(--text-color-alt);\n  border: var(--border-size) var(--border-style) var(--border-color);\n  border-radius: var(--box-rounding);\n  padding: var(--spacing-less) var(--spacing);\n  margin-right: var(--spacing);\n  font-weight: bold;\n}\n\ninput::file-selector-button:hover {\n  color: var(--hover-color);\n  border-color: var(--border-color-alt);\n}\n\ninput[type='checkbox'] {\n  width: auto;\n  accent-color: var(--primary-color);\n  cursor: pointer;\n}\n\ninput[type='checkbox']:checked {\n  accent-color: var(--secondary-color);\n}\n\ninput[type='checkbox']:checked::before {\n  font-weight: bold;\n  color: var(--secondary-color);\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\nbutton {\n  display: inline-block;\n  text-decoration: none;\n  border: var(--border-size) var(--border-style) var(--border-color);\n  background: var(--background-alt);\n  color: var(--text-color-alt);\n  border-radius: var(--box-rounding);\n  font-weight: bold;\n  font-size: larger;\n  text-align: center;\n  padding: var(--spacing-less) var(--spacing);\n}\n\nbutton:hover {\n  color: var(--hover-color);\n  border-color: var(--border-color-alt);\n}\n\n.app {\n  min-width: var(--min-width);\n  max-width: var(--max-width);\n  margin: auto;\n  padding: var(--spacing);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
